<template>

    <li class="admin-nav-item">
        <button type="button" class="admin-nav-link" :class="linkClasses" :aria-current="active ? 'page' : null"
            v-tooltip="tooltipConfig">
            <i v-if="icon" :class="icon" class="admin-nav-link__icon" aria-hidden="true"></i>
            <span class="admin-nav-link__text">{{ text }}</span>
        </button>
    </li>

</template>

<script>
/**
 * Item da navegação lateral do admin.
 *
 * `<button>` de verdade (foco por teclado, Enter/Espaço) em vez de `<li>`
 * clicável. O `@click` do pai continua chegando pelo fallthrough para a raiz
 * `<li>` — mesmo contrato de antes. A aparência vive em `assets/css/admin.css`
 * (seção "Sidebar").
 */
    export default {
        name: 'ButtonNavBarAdmin',
        inject: {
            /** Fornecido pela `NavBarLeftAdmin`: com a lateral recolhida o texto some e o
                tooltip passa a ser o rótulo. */
            sidebarRecolhida: { default: () => () => false },
        },
        props: {
            icon: {
                type: String
            },
            text: {
                type: String
            },
            active:{
                type: Boolean,
                default: false
            },
            /** `info` | `danger` | `success` | `warning` — cor semântica do item. */
            textColor:{
                type: String
            }
        },
        computed: {
            linkClasses() {
                return {
                    'is-active': this.active,
                    'admin-nav-link--info': this.textColor == 'info',
                    'admin-nav-link--danger': this.textColor == 'danger',
                    'admin-nav-link--success': this.textColor == 'success',
                    'admin-nav-link--warning': this.textColor == 'warning',
                };
            },
            tooltipConfig() {
                const recolhida = typeof this.sidebarRecolhida === 'function'
                    ? this.sidebarRecolhida()
                    : !!this.sidebarRecolhida;
                return { content: this.text, placement: 'right', distance: 10, disabled: !recolhida };
            },
        },
    }
</script>
